import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesContext = /*#__PURE__*/createContext(undefined);
export default function ListingProvider({
  children,
  enableObjectLevelPermissions,
  objectType,
  uiModeProps,
  viewProps,
  skipCrm,
  _useNonGqlCRMSearch
}) {
  const value = useMemo(() => ({
    enableObjectLevelPermissions,
    objectType,
    uiModeProps,
    viewProps,
    skipCrm,
    _useNonGqlCRMSearch
  }), [enableObjectLevelPermissions, objectType, uiModeProps, viewProps, skipCrm, _useNonGqlCRMSearch]);
  return /*#__PURE__*/_jsx(PropertiesContext.Provider, {
    value: value,
    children: children
  });
}
export function useListing() {
  const context = useContext(PropertiesContext);
  if (context === undefined) {
    throw new Error('useListing must be used within a ListingProvider');
  }
  return context;
}